import * as actionTypes from '../constants/action-types';

const initialState = {
  isRequesting: false,
  scaleInfo: [],
  message: ""
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SAVE_SCALE_DEVICE_REQUEST: {
      state = { ...state, isRequesting: true, scaleInfo: initialState.scaleInfo }
      break;
    }

    case actionTypes.SAVE_SCALE_DEVICE_SUCCESS: {
      state = {
        ...state,
        isRequesting: false,
        scaleInfo: action.payload,
      };
      break;
    }

    case actionTypes.GET_SCALE_DEVICE_LIST_REQUEST: {
      state = {
        ...state,
        isRequesting: true
      };
      break;
    }

    case actionTypes.GET_SCALE_DEVICE_LIST: {
      state = {
        ...state,
        isRequesting: false,
        scaleInfo: action.payload.data
      };
      break;
    }

    case actionTypes.DELETE_SCALE_DEVICE_REQUEST: {
      state = { ...state, isRequesting: true }
      break;
    }

    case actionTypes.DELETE_SCALE_DEVICE_SUCCESS: {
      state = {
        ...state,
        isRequesting: false,
        message: action.payload,
      };
      break;
    }

    case actionTypes.UPDATE_SCALE_DEVICE_REQUEST: {
      state = { ...state, isRequesting: true, scaleInfo: initialState.scaleInfo }
      break;
    }

    case actionTypes.UPDATE_SCALE_DEVICE_SUCCESS: {
      state = {
        ...state,
        isRequesting: false,
        scaleInfo: action.payload,
      };
      break;
    }

    default:
      break;
  }
  return state;
};